export const FORMERROR_RESETFORMERRORSTATE = 'REDUX_FORMERROR_RESETFORMERRORSTATE';
export const FORMERROR_SETFORMERRORSTATE = 'REDUX_FORMERROR_SETFORMERRORSTATE';
export const RESET_FORM_FIELDVALUES_STATE = 'REDUX_RESET_FORM_FIELDVALUES_STATE';
export const SET_FROM_FIELDVALUE_STATE = 'REDUX_SET_FROM_FIELDVALUE_STATE';

export const actionResetFormErrorState = (dispatch) => {
    dispatch({ type: FORMERROR_RESETFORMERRORSTATE });
};

export const actionSetFormErrorState = (dispatch, errorfield, errortext, errorstate) => {
    dispatch({ type: FORMERROR_SETFORMERRORSTATE, payload: { errorfield: errorfield, errortext: errortext, errorstate: errorstate } });
};

export const actionResetFieldValuesState = (dispatch) => {
    dispatch({ type: RESET_FORM_FIELDVALUES_STATE });
};

export const actionSetFieldValueState = (dispatch, field, value) => {
    dispatch({ type: SET_FROM_FIELDVALUE_STATE, payload: { field: field, value: value } });
};